var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-container"},[_c('h2',{staticClass:"section-title",domProps:{"innerHTML":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }